"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/search/v1/legacy_portal_service.proto (package spwn.search.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalSearchService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.search.v1.LegacyPortalSearchService
 */
exports.LegacyPortalSearchService = {
    typeName: "spwn.search.v1.LegacyPortalSearchService",
    methods: {
        /**
         * イベント一覧の検索
         *
         * @generated from rpc spwn.search.v1.LegacyPortalSearchService.SearchEvent
         */
        searchEvent: {
            name: "SearchEvent",
            I: legacy_portal_service_pb_1.LegacyPortalSearchServiceSearchEventRequest,
            O: legacy_portal_service_pb_1.LegacyPortalSearchServiceSearchEventResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * グッズ一覧の検索
         *
         * @generated from rpc spwn.search.v1.LegacyPortalSearchService.SearchGoods
         */
        searchGoods: {
            name: "SearchGoods",
            I: legacy_portal_service_pb_1.LegacyPortalSearchServiceSearchGoodsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalSearchServiceSearchGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * イベント詳細検索用の条件取得
         *
         * @generated from rpc spwn.search.v1.LegacyPortalSearchService.GetEventSearchConditions
         */
        getEventSearchConditions: {
            name: "GetEventSearchConditions",
            I: legacy_portal_service_pb_1.GetEventSearchConditionsRequest,
            O: legacy_portal_service_pb_1.GetEventSearchConditionsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map